import React, { useContext, useEffect, useState } from "react";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Modal from "../../components/Genericos/Modal/Modal";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import { PortalContext } from "../../context/Provider";
import { GlobalContext } from "../../../global/context/Provider";
import { displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";
import PreguntaFrecuenteItem from "../../components/Turnos/PreguntasFrecuentes/PreguntasFrecuentes";
import { wsGetFAQPortal } from "../../context/Actions/preguntasFrecuentes/preguntasFrecuentesPortal";
import { showToaster } from "global/context/action/toaster/toaster";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import Loading from "../../components/Genericos/Loading/Loading";
import "./PreguntasFrecuentes.css";

const PreguntasFrecuentes = () => {
  const { modalState, ayudaDispatch, preguntasFrecuentesDispatch, preguntasFrecuentesState } =
    useContext(PortalContext);
  const { toasterState, toasterDispatch } = useContext(GlobalContext);

  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [selected, setSelected] = useState(null);
  const [dataFAQ, setDataFAQ] = useState(null);

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const selectItem = (id) => {
    setSelected((prev) => (prev === id ? null : id));
  };

  const cargarDataFAQ = (isCorrect, data) => {
    if (isCorrect) {
      const faqsWithIds = data.map((faq, index) => ({
        ...faq,
        id: index + 1,
      }));
      setDataFAQ(faqsWithIds);
    } else {
      showToaster(
        {
          texto: data ? data : "Error al cargar preguntas frecuentes",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyudaMobile("hidden");
    }, 250);
    wsGetFAQPortal(cargarDataFAQ)(preguntasFrecuentesDispatch);
  }, []);

  const isLoading = preguntasFrecuentesState?.preguntasFrecuentes?.loading;

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Preguntas frecuentes"} />
      <div className="pfr-bodyContainer">
        <Sidebar />
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="pfr-mainContent"
        >
          {isLoading ? (
            <Loading
              dataLoading={isLoading}
              color="c-white"
              descripcion={"Cargando preguntas frecuentes..."}
            />
          ) : Array.isArray(dataFAQ) && dataFAQ.length > 0 ? (
            <div className="pfr-lista">
              {dataFAQ.map((item, index) => (
                <PreguntaFrecuenteItem
                  key={index}
                  item={item}
                  selected={selected}
                  handleClickMenu={() => selectItem(index + 1)}
                />
              ))}
            </div>
          ) : dataFAQ !== null ? (
            <p className="rb14l pfr-sinResultados">
              No hay preguntas frecuentes disponibles en este momento.
            </p>
          ) : null}
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default PreguntasFrecuentes;
